export default (api) => {
    return {
        index: options => api.get('curriculums', options),
        getByCode: (code, options) => api.get(`curriculums/code/${code}`, options),
        get: (curriculum_id, options) => api.get(`curriculums/${curriculum_id}`, options),
        getMap: (code, options) => api.get(`curriculums/${code}/map`, options),
    }
}
